import { appt_status, appt_type_show, appt_sub_type } from '../admin/variables/patient'

export const reorderData = (dataList) => {
  var upcoming = []
  var future = []
  var past = []
  var cancel = []
  var st = ''
  var buff = {}
  dataList.map(item => {
    st = genAppointmentStatus(item.appt_date, item.appt_time, item.status, item.main_recurrent_id, item.recurrent_end_date)
    buff = {
      id: item.id,
      pid: item.pid,
      cid: item.cid,
      type: appt_type_show[item.type],
      sub_type_id: item.sub_type,
      sub_type: findLabelByValue(appt_sub_type, item.sub_type),
      provider: (item.cid == 1 && item.c_other_name) || (item.cid > 1 && item.c_name) || (item.aid > 1 && item.a_name),
      appt: item.appt_date+', '+item.appt_time,
      appt_date: item.appt_date,
      appt_time: item.appt_time,
      st: st,
      status: item.status,
      ct_id: item.ct_id,
      notes: item.notes,
      notes_id: item.notes_id,
    }
    if(st == 'Upcoming' || st == 'Upcoming (Recurrent)') {
      upcoming.push(buff)
    } else if(st == 'Canceled' || st == 'Canceled (Recurrent)') {
      cancel.push(buff)
    } else if(st == 'Future' || st == 'Future (Recurrent)') {
      future.push(buff)
    } else if(st == 'Past' || st == 'No-show' || st == 'Past (Recurrent)' || st == 'No-show (Recurrent)') {
      past.push(buff)
    }
  })
  var cnt = 0
  var newOrder = []
  upcoming.reverse()
  future.reverse()
  upcoming.map(item => {
    cnt++
    newOrder.push({ row_number: cnt, item: item })
  })
  future.map(item => {
    cnt++
    newOrder.push({ row_number: cnt, item: item })
  })
  past.map(item => {
    cnt++
    newOrder.push({ row_number: cnt, item: item })
  })
  cancel.map(item => {
    cnt++
    newOrder.push({ row_number: cnt, item: item })
  })
  return newOrder
}

export function genAppointmentStatus(
  appt_date,
  appt_time,
  status,
  main_recurrent_id,
  recurrent_end_date
) {
  const isRecurrent = Number(main_recurrent_id) > 0
  const recurrentText = isRecurrent ? ' (Recurrent)' : ''

  // Status overrides
  if (Number(status) === 3) {
    return `Canceled${recurrentText}`
  }

  if (Number(status) === 5) {
    return `No-show${recurrentText}`
  }

  // Supports:
  // YYYY-MM-DD
  // YYYY/MM/DD
  // MM/DD/YYYY
  // MM-DD-YYYY
  const dateParts = String(appt_date || '')
    .trim()
    .split(/[/-]/)

  if (dateParts.length !== 3) {
    return `Future${recurrentText}`
  }

  let year
  let month
  let day

  if (dateParts[0].length === 4) {
    // YYYY-MM-DD
    year = Number(dateParts[0])
    month = Number(dateParts[1])
    day = Number(dateParts[2])
  } else {
    // MM/DD/YYYY
    month = Number(dateParts[0])
    day = Number(dateParts[1])
    year = Number(dateParts[2])
  }

  // Supports HH:mm, HH:mm:ss, h:mm AM, and h:mm:ss PM
  const timeString = String(appt_time || '').trim()
  let hour = 0
  let minute = 0
  let second = 0

  const timeMatch = timeString.match(
    /^(\d{1,2})(?::(\d{2}))?(?::(\d{2}))?\s*(AM|PM)?$/i
  )

  if (timeMatch) {
    hour = Number(timeMatch[1])
    minute = Number(timeMatch[2] || 0)
    second = Number(timeMatch[3] || 0)

    const period = timeMatch[4]?.toUpperCase()

    if (period === 'PM' && hour < 12) {
      hour += 12
    } else if (period === 'AM' && hour === 12) {
      hour = 0
    }
  }

  const appointmentDate = new Date(
    year,
    month - 1,
    day,
    hour,
    minute,
    second
  )

  // Validate the date because JavaScript automatically normalizes invalid dates
  const isValidDate =
    Number.isInteger(year) &&
    Number.isInteger(month) &&
    Number.isInteger(day) &&
    month >= 1 &&
    month <= 12 &&
    day >= 1 &&
    day <= 31 &&
    appointmentDate.getFullYear() === year &&
    appointmentDate.getMonth() === month - 1 &&
    appointmentDate.getDate() === day

  if (!isValidDate) {
    return `Future${recurrentText}`
  }

  const now = new Date()
  const sevenDaysFromNow = new Date(now)
  sevenDaysFromNow.setDate(now.getDate() + 7)

  if (appointmentDate.getTime() < now.getTime()) {
    return `Past${recurrentText}`
  }

  if (appointmentDate.getTime() <= sevenDaysFromNow.getTime()) {
    return `Upcoming${recurrentText}`
  }

  return `Future${recurrentText}`
}

function findLabelByValue(arr, searchValue) {
  var label = ''
  var result = arr.find(obj => {
    return obj.value == searchValue
  })
  if(typeof result !== "undefined") {
    label = result.label
  }
  return label
}
